import React from "react";
import "./LoadingModal.css"; // Add CSS for styling
import Logo from "../../assets/logo-load.png";

const LoadingModal = ({ open }) => {
  return (
    <div
      className={`absolute ${
        open ? "" : "hidden"
      } z-[1000] inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full mx-auto`}
    >
      <div className="relative mx-auto p-5 w-3/4 rounded-md h-full overflow-hidden">
        <div className="ring flex justify-center bg-white p-5">
          <img src={Logo} alt="Loading" className="h-20 mt-[16px]" />
          <span className="spinner"></span>
        </div>
      </div>
    </div>
  );
};

export default LoadingModal;
